class UtilityUpdateFontSize {
    constructor() {
        this.bindEvents();
    }

    bindEvents() {
        if (window.innerWidth >= 1024) {
            window.addEventListener("resize", this.updateFontSize);
        }
        window.addEventListener("load", this.updateFontSize);
    }

    updateFontSize() {
        const baseWidth = 1680; // Largeur de référence pour la maquette
        const minWidth = 1024;   // Premier breakpoint
        const minFontSize = 16; // Taille min en px (pour < 768px)
        const maxFontSize = 22; // Taille max en px
        const defaultMobileFontSize = 16; // Taille par défaut pour mobile
      
        let screenWidth = window.innerWidth;
        let newFontSize;
      
        if (screenWidth < minWidth) {
          newFontSize = defaultMobileFontSize; // Taille fixe pour mobile
        } else {
          newFontSize = (screenWidth / baseWidth) * minFontSize;
          newFontSize = Math.min(newFontSize, maxFontSize);
        }
      
        document.documentElement.style.fontSize = `${newFontSize}px`;
        document.documentElement.style.visibility = "visible";

      // Dispatch custom event when font size is updated
      window.dispatchEvent(new CustomEvent('font-size-updated'));
      }

    static load() {
        new UtilityUpdateFontSize()
    }
}

document.addEventListener('DOMContentLoaded', () => {
  UtilityUpdateFontSize.load();
});